import type { ComponentPropsWithoutRef } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

export interface FormItemWrapper extends ComponentPropsWithoutRef<"div"> {}

export const FormItemWrapper = ({
  className,
  children,
  ...rest
}: FormItemWrapper) => (
  <div className={classNames("col-span-2", className)} {...rest}>
    {children}
  </div>
);
